module.exports = __webpack_public_path__ + "img/bg-1.e0a7d8d9.svg";